import { Plugins } from "@capacitor/core";
const { Storage } = Plugins;

async function setItem(key, value) {
  await Storage.set({
    key: key,
    value: value
  });
}

async function getItem(key) {
  const item = await Storage.get({ key: key });
  return item.value;
}

async function removeItem(key) {
  await Storage.remove({
    key: key
  });
}

export default {
  setItem,
  getItem,
  removeItem
}